import { z } from 'zod';
import { FilterFieldOperator } from '@/components/table/_filterFieldOperators/FilterFieldOperator.ts';

const urlFilterSchema = z.object({
  f: z.string().min(1).max(64),
  o: z.enum(FilterFieldOperator),
  v: z.string().max(200),
  v2: z.string().max(200).optional(),
});

/**
 * Wycinek ekranu listy: `?query=` (fraza szukania), `?quick=` (quick filtry po id) i `?filters=`
 * (filtry pól). To stan początkowy tabeli, nie jej lustro — tabela nie zapisuje zmian z powrotem.
 * `.catch(undefined)` to fallback dla starych albo zepsutych linków: ekran otwiera się bez filtra.
 */
export const listSearchSchema = z.object({
  query: z.string().trim().min(1).max(100).optional().catch(undefined),
  quick: z
    .record(z.string().min(1).max(64), z.boolean())
    .optional()
    .catch(undefined),
  filters: z.array(urlFilterSchema).max(4).optional().catch(undefined),
});

export type ListSearch = z.infer<typeof listSearchSchema>;
export type UrlFilter = z.infer<typeof urlFilterSchema>;

/** Tabela czyta wycinek raz, więc inny wycinek musi dać inny klucz — kolejność kluczy w adresie bez znaczenia. */
export const listSearchKey = (search: ListSearch | undefined): string =>
  JSON.stringify([
    search?.query ?? null,
    search?.quick ?? null,
    search?.filters ?? null,
  ]);
